import React from "react";
import {
    Dialog,
    DialogTitle,
    Typography,
    DialogActions,
    Button,
    DialogContent,
} from "@mui/material";
import { createStringDataField } from "../../../util/format";
import { StringEquators } from "../../../store/constants/pages";
import { XClientDataGrid } from "../../../common";

const ImportInfoDialog = ({ handleClose, open, importData }) => {
    console.log("import item", importData);
    const fields = [
        createStringDataField("Payer Name", "Payer Name", {
            equators: StringEquators,
        }),
        createStringDataField("Payer Type", "Payer Type", {
            equators: StringEquators,
        }),
        createStringDataField("Plan Id", "Plan Id", {
            equators: StringEquators,
        }),
    ];

    const parseRecords = (records) =>
        records?.map(
            (record, index) =>
                record
                    ? {
                          id: index, 
                          ...Object.fromEntries(
                              record
                                  .split(", ")
                                  .map((pair) =>
                                      pair.split(":").map((val) => val.trim())
                                  )
                                  .filter(([key, value]) => key && value)
                          ),
                      }
                    : { id: index } 
        );

    return (
        <Dialog
            open={open}
            sx={{
                "& .MuiPaper-root": {
                    minWidth: "350px",

                    maxHeight: "570px",
                },
            }}
            onClose={handleClose}
        >
            <DialogTitle>Payer Mapping Import</DialogTitle>

            <DialogContent>
                <Typography sx={{ mb: "5px" }}>
                    Total Records : <b> {importData?.length}</b>
                </Typography>

                <XClientDataGrid
                    fields={fields}
                    data={parseRecords(importData) || []}
                    // sortPtr={sortPtr}
                    loading={false}
                    hideFooter
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}> Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImportInfoDialog;
